import { WorkspaceEventsScene } from '@/features/workspaces/WorkspaceEventsScene';
import { useLocalSearchParams } from 'expo-router';

export default function WorkspaceEventsScreen() {
  const { id } = useLocalSearchParams<{ id?: string }>();
  const organizationID = typeof id === 'string' ? id : '';

  return <WorkspaceEventsScene organizationID={organizationID} />;
}
